import { Modal, Stack } from "@mantine/core"
import { useForm } from "@mantine/form"
import { notifications } from "@mantine/notifications"
import { Button, ErrorBox } from "@tfg/ui"
import { useTranslation } from "react-i18next"

import {
  TransferCertificateRequestRequestDto,
  useTransferCertificateRequest,
} from "~/gen/api"
import { ContactSelect } from "~/pages/SupplierPortal/TraceabilityRequests/components/ContactSelect.tsx"
import { useAuth } from "~/store/auth-context"

interface Props {
  certificateRequestId: string | undefined
  opened: boolean
  close: () => void
}
export const TransferCertificateRequestModal = ({
  certificateRequestId,
  opened,
  close,
}: Props) => {
  const { t } = useTranslation("traceability")
  const { mutate, isLoading, error } = useTransferCertificateRequest({
    mutation: {
      onSuccess: () => {
        close()
        notifications.show({
          message: t("transferModal.success"),
          color: "green",
        })
      },
    },
  })
  const { user, isAdmin } = useAuth()

  const form = useForm<TransferCertificateRequestRequestDto>()

  if (!user?.id) {
    return null
  }
  return (
    <Modal title={t("transferModal.title")} opened={opened} onClose={close}>
      <form onSubmit={form.onSubmit((values) => mutate(values))}>
        <Stack>
          <ErrorBox error={error} />

          <ContactSelect
            contactId={form.values.contactId}
            onContactSelected={(contactId) => {
              contactId && form.setFieldValue("contactId", contactId)
              certificateRequestId &&
                form.setFieldValue("certificateRequestId", certificateRequestId)
            }}
            userId={user?.id}
            isAdmin={isAdmin}
          />
          <Button type="submit" disabled={!form.isValid()} loading={isLoading}>
            {t("certificates.actions.transfer")}
          </Button>
        </Stack>
      </form>
    </Modal>
  )
}
